import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import VisibilitySensor from 'react-visibility-sensor';

import { injectConfig, configShape } from '@client/hoc/config';

import {
    track,
    visibleOnce
} from '../../../helpers';
import {
    getBannerImpressionData,
    getBannerClickData
} from '../../../helpers/tracking';
import HiddenCampaign from '../HiddenCampaign';

import styles from './customElement.scss';

export function CustomElement({ config, element, dimension, elementStyles, id, position, hiddenCampaign }) {
    if (!element.images) {
        return null;
    }
    const backgrounImageUrl = `${config.getUrl('media')}${element.images[dimension].normal}`;
    const style = {
        ...elementStyles,
        backgroundImage: !hiddenCampaign && `url(${backgrounImageUrl})`,
        left: `${elementStyles.left}%`,
        paddingTop: `${elementStyles.paddingTop}%`,
        width: `${elementStyles.width}%`,
        marginTop: `${elementStyles.marginTop}%`
    };

    const clickFunc = function(banner) {
        return function() {
            if (id === 'newsletter_resignup') {
                const payload = getBannerClickData(banner);
                track('bannerClick', payload);

                track('CCM_banner_nwl');
                setTimeout(() => {
                    // Using window.top makes sure that it navigates the top most window
                    // This resolves any issues with iframe navigation
                    window.top.location.href = '/myaccount/newsletter#panel=myaccount-newsletter-subscribe';
                }, 300);
            }
        };
    };

    const visibleFunc = function(banner) {
        const payload = getBannerImpressionData(banner);
        track('eec_impressions', payload);
    };

    return (
        <VisibilitySensor
            onChange={visibleOnce({ banner: element, position }, visibleFunc)}
            delayedCall={true}
            partialVisibility={true}
        >
            <div>
                <div
                    styleName="wrapper"
                    style={style}
                    id={id}
                    onClick={clickFunc({ banner: element, position })}
                >
                    {hiddenCampaign && <HiddenCampaign campaign={hiddenCampaign} onGrid />}
                </div>
            </div>
        </VisibilitySensor>
    );

}

CustomElement.propTypes = {
    element: PropTypes.object.isRequired,
    dimension: PropTypes.string.isRequired,
    elementStyles: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
    hiddenCampaign: PropTypes.object,
    config: configShape,
};

export default injectConfig(
    CSSModules(CustomElement, styles)
);
